export default {
  SET_BACK (state, status) {
    state.back = status
  },
  SET_LOADER (state, status) {
    state.loader = status
  }
}



// WEBPACK FOOTER //
// ./src/store/navigation/mutations.js